import styled from 'styled-components';

type CategoryTagProps = {
  background: string;
};

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 6.55rem 0 1rem;

  @media (min-width: 1024px) {
    gap: 2rem;
  }
`;

export const CategoryTag = styled.h1<CategoryTagProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 800;
  background: ${({ background }) => background && background};
  font-size: 1rem;
  color: var(--text-color-secondary);
  text-transform: uppercase;
  padding: 0rem 0.5rem;
  height: 2rem;

  @media (min-width: 1024px) {
    font-size: 1.25rem;
    height: 2.5rem;
    padding: 0rem 1rem;
  }
`;

export const CategoryPrev = styled.span`
  font-family: 'JetBrains Mono', sans-serif;
  font-size: 1.625rem;
  font-weight: 800;
  color: var(--highlight-blue);
  text-transform: uppercase;

  @media (min-width: 1024px) {
    font-size: 3rem;
  }
`;

export const Content = styled.section`
  padding: 2.5rem 0;
  width: 85%;
  max-width: var(--max-width);
  border-bottom: 1px solid #dddddd;
  margin: 0 auto;

  @media (min-width: 1024px) {
    padding: 4.25rem 0;
    max-width: 1170px;
  }
`;
